import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  ModalBody,
  ModalHeader,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import ShareLinksModalUserListItem from './LinksModalUserListItem';
import ShareLinksModalAnonymousLinkItem from './LinksModalAnonymousLinkItem';

import ErrorBoundary from '../ErrorBoundary';

const ShareLinksModal = ({ share, handleClose }) => {
  const linkShare = share.links.find(l => ((!l.shared_email && !l.shared_user)));
  const noGroupUsers = share.links
    .filter(l => (!l.shared_group))
    .filter(l => (l.shared_email || l.shared_user));

  const intl = useIntl();

  return (
    <ErrorBoundary>
      <ModalHeader toggle={handleClose} className="modal-header-center">
        {intl.formatMessage({ defaultMessage: 'Share Recipients' })}
      </ModalHeader>

      <ModalBody>
        <div className="share-body">
          <div className="share-users-list">
            {linkShare && (
              <ShareLinksModalAnonymousLinkItem
                link={linkShare}
              />
            )}
            {share.groups.map(sg => (
              <Fragment key={sg.uuid}>
                <h5>{intl.formatMessage({ defaultMessage: 'Group: {name}' }, { name: sg.name })}</h5>
                {share.links
                  .filter(l => (l.shared_group && l.shared_group.uuid === sg.uuid))
                  .filter(l => (l.shared_email || l.shared_user))
                  .map(link => (
                    <ShareLinksModalUserListItem
                      key={link.uuid}
                      link={link}
                    />
                  ))}
              </Fragment>
            ))}
            {(share.groups.length > 0 && noGroupUsers.length > 0) && (
              <h5>{intl.formatMessage({ defaultMessage: 'No Group' })}</h5>
            )}
            {noGroupUsers.map(link => (
              <ShareLinksModalUserListItem
                key={link.uuid}
                link={link}
              />
            ))}
          </div>
        </div>
      </ModalBody>
    </ErrorBoundary>
  );
};

ShareLinksModal.propTypes = {
  share: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default ShareLinksModal;
